export default __webpack_public_path__ + "static/media/clouds.38fd00be.svg";